import React from 'react';

import { STFlex } from 'design/atoms/Container';
import { BaseText } from 'design/atoms/Text';
import { Range, getTrackBackground, Direction } from 'react-range';
import { useMedia } from 'src/shared/hooks/useMedia';
import { analytics } from 'src/utils/firebase';

const STEP = 1;
const MIN = 1;
const MAX = 7;

const milestoneLabel = (index, matches) => {
  if (index === 0) {
    return;
  } else if (index === 6) {
    return `${index} ${!matches.xLarge ? 'M+' : 'million+'}`;
  } else {
    return `${index} ${!matches.xLarge ? 'M' : 'million'}`;
  }
};

const RangeSlider = ({ rangeValue }) => {
  const [values, setValue] = React.useState([2]);
  const matches = useMedia();
  return (
    <STFlex width="100%" my={3}>
      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        disabled={false}
        direction={Direction.Right}
        onChange={values => {
          analytics.logEvent('slider_change', {
            amount_set_to: values[0] - 1 ? `${values[0] - 1} million` : 0,
          });
          setValue(values);
          rangeValue(values);
        }}
        renderMark={({ props, index }) => {
          return (
            <div
              {...props}
              style={{
                ...props.style,
                height: !matches.large ? '15px' : '20px',
                width: !matches.large ? '15px' : '20px',
                borderRadius: '50px',
                backgroundColor: 'white',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
              }}
            >
              <BaseText
                marginTop="30px"
                fontFamily="Montserrat"
                fontWeight={600}
                fontSize={[index === 6 ? '8px' : '8px', '10px']}
                color={index === values[0] - 1 ? '#006FAE' : '#707070'}
                width={[index === 6 ? '50px' : '18px', '80px']}
                textAlign={['center', 'start']}
                style={{
                  position: 'relative',
                  left: index === 6 && !matches.large ? '-25px' : 0,
                }}
              >
                {milestoneLabel(index, matches)}
              </BaseText>
            </div>
          );
        }}
        renderTrack={({ props, children }) => {
          return (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '36px',
                display: 'flex',
                width: '100%',
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: '5px',
                  width: '100%',
                  borderRadius: '4px',
                  background: getTrackBackground({
                    values,
                    colors: ['#F5AC30', '#E5E5E5'],
                    min: MIN,
                    max: MAX,
                  }),
                  alignSelf: 'center',
                }}
              >
                {children}
              </div>
            </div>
          );
        }}
        renderThumb={({ props, isDragged }) => {
          return (
            <div
              {...props}
              style={{
                ...props.style,
                height: !matches.large ? '25px' : '35px',
                width: !matches.large ? '25px' : '35px',
                borderRadius: '50px',
                backgroundColor: '#FFF',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
              }}
            ></div>
          );
        }}
      />
    </STFlex>
  );
};

export default RangeSlider;
